module.exports = __webpack_public_path__ + "img/form-empty.c0979f0e.png";